import i18n from '@shared/i18n'

import {
  SidebarData,
  SidebarData_Module,
  SidebarData_SidebarItem,
} from '@protos/sidebar/sidebar_data_pb'

import { PlainMessage } from '@bufbuild/protobuf'
import { JsonValue } from '@protobuf-ts/runtime'

export const sidebarDataProvider = () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const sidebarData: PlainMessage<SidebarData> = window.sidebarData

  const sidebarItems: SidebarData_SidebarItem[] =
    sidebarData?.sidebarItems?.map((item) => {
      return SidebarData_SidebarItem.fromJson((item || {}) as JsonValue)
    }) ?? []

  const primaryColor: string = sidebarData?.brandingSettings?.primaryColor || ''

  const avatarUrl: string = sidebarData?.user?.avatarUrl || ''

  return { sidebarItems, primaryColor, avatarUrl }
}

export const SHAPE_BY_SIDEBAR = {
  [SidebarData_Module.BOT_DESIGNER]: 'bd',
  [SidebarData_Module.CARE_CAMPAIGNS]: 'cc',
  [SidebarData_Module.CHAT_WIDGETS]: 'chat-bubble',
  [SidebarData_Module.FAQS]: 'help-info',
  [SidebarData_Module.GPT_STORE]: 'gp',
  [SidebarData_Module.GROUP_SETTINGS]: 'administrator',
  [SidebarData_Module.ONCALL]: 'event',
  [SidebarData_Module.QUICK_FORMS]: 'qf',
  [SidebarData_Module.QUICK_SIGNS]: 'qs',
  [SidebarData_Module.REPORTS]: 'rp',
  [SidebarData_Module.SELF_SCHEDULES]: 'calendar',
  [SidebarData_Module.VIRTUAL_CONVERSATIONS]: 'talk-bubbles',
  [SidebarData_Module.VISIT_PATH]: 'map-marker',
  [SidebarData_Module.UNKNOWN]: '',
}

export const TOOLTIPTEXT_BY_SIDEBAR = {
  [SidebarData_Module.BOT_DESIGNER]: i18n.global.t('sidebarTooltips.bd'),
  [SidebarData_Module.CARE_CAMPAIGNS]: i18n.global.t('sidebarTooltips.cc'),
  [SidebarData_Module.CHAT_WIDGETS]: i18n.global.t('sidebarTooltips.cw'),
  [SidebarData_Module.FAQS]: i18n.global.t('sidebarTooltips.faq'),
  [SidebarData_Module.GPT_STORE]: i18n.global.t('sidebarTooltips.gp'),
  [SidebarData_Module.GROUP_SETTINGS]: i18n.global.t('sidebarTooltips.gs'),
  [SidebarData_Module.ONCALL]: i18n.global.t('sidebarTooltips.oc'),
  [SidebarData_Module.QUICK_FORMS]: i18n.global.t('sidebarTooltips.qf'),
  [SidebarData_Module.QUICK_SIGNS]: i18n.global.t('sidebarTooltips.qs'),
  [SidebarData_Module.REPORTS]: i18n.global.t('sidebarTooltips.rp'),
  [SidebarData_Module.SELF_SCHEDULES]: i18n.global.t('sidebarTooltips.ss'),
  [SidebarData_Module.VIRTUAL_CONVERSATIONS]:
    i18n.global.t('sidebarTooltips.vc'),
  [SidebarData_Module.VISIT_PATH]: i18n.global.t('sidebarTooltips.vp'),
  [SidebarData_Module.UNKNOWN]: '',
}
